// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".f6v4FTRWoxbG2JREuE_cI{-webkit-backdrop-filter:blur(10px);backdrop-filter:blur(10px);background-color:var(--blurredBackgroundColor);bottom:0;left:0;position:fixed;width:100%;z-index:150}.f6v4FTRWoxbG2JREuE_cI ._2b8wRbCiqTjHstlfJAHnTv{position:relative}.RO6CmwkmerGiDU-QF1xPs{flex:1;box-sizing:border-box;padding:12px 20px}.AQV0Kjn_T2drr-rKeSWh_{color:var(--fadedTextColor);opacity:.6;font-size:15px;font-weight:500}@media screen and (max-width: 1200px){.AQV0Kjn_T2drr-rKeSWh_{font-size:12px;font-weight:500}}", ""]);
// Exports
exports.locals = {
	"mainBackgroundColor": "#fff",
	"cardBackgroundColor": "#fff",
	"cardSecondaryBackgroundColor": "#fff",
	"blurredBackgroundColor": "rgba(255,255,255,.9176470588)",
	"fadedTextColor": "#596269",
	"blurredAdornmentColor": "#a9a9a9",
	"focusedAdornmentColor": "#000",
	"primaryItemColor": "#346094",
	"primaryItemBackdropColor": "rgba(50,103,168,.24)",
	"primaryItemLightColor": "rgba(52,95,148,.1921568627)",
	"dividerColor": "#f5f5f5",
	"generalTextColor": "#000",
	"areaChartNegativeColor": "#f7e0e3",
	"areaChartPositiveColor": "#e0f6e6",
	"secondaryButtonBackgroundColor": "#f7fafc",
	"secondaryButtonBackgroundHoverColor": "#d2e3ee",
	"colorOverlay": "rgba(255,255,255,.7)",
	"greyBackgroundColor": "#f8f8f8",
	"inputBorderColor": "rgba(0,0,0,.15)",
	"inputBorderActiveColor": "rgba(213,213,213,.438)",
	"disabledButtonText": "#fff",
	"scrollbarColor": "#e9e9e9",
	"segmentedControlBackgroundColor": "#f0f7ff",
	"segmentedControlActiveColor": "#336094",
	"positiveValueColor": "#02b334",
	"positiveValueLighterColor": "rgba(2,179,52,.16)",
	"negativeValueColor": "#b2292e",
	"negativeValueLighterColor": "rgba(178,41,46,.16)",
	"futuresColor": "#28bbd6",
	"fplGreen": "\"#13B53F\"",
	"futuresBackdropColor": "rgba(40,188,214,.2196078431)",
	"stickyCard": "#ffc",
	"selectListItemColor": "rgba(51,96,148,.1)",
	"selectListSelectedItemColor": "#346094",
	"wrapper": "f6v4FTRWoxbG2JREuE_cI",
	"non-fixed": "_2b8wRbCiqTjHstlfJAHnTv",
	"cell": "RO6CmwkmerGiDU-QF1xPs",
	"cellLabel": "AQV0Kjn_T2drr-rKeSWh_"
};
module.exports = exports;
